import { Flex } from "Element/Flex";
import styled from "styled-components";
import mintedFrame from "assets/images/dogehof.png";
import NextIcon from "assets/icons/arrow-right.svg";
import PrevIcon from "assets/icons/arrow-left.svg";

export const CarouselWrapper = styled.div`
  width: 80%;
  margin: 0 auto 100px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    .slick-list{
      padding: 0 50% 0 50% !important;
    }
    width: 100%;
  `}
`;

export const MintedDogeWrapper = styled.div`
  position: relative;
  height: 230px;
  background: url(${mintedFrame});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  ${({ theme }) => theme.mediaWidth.upToXxs`
    height: 250px;
  `}
`;

export const MintedInfo = styled(Flex)`
  width: 138px;
  height: 198px;
  margin: 10px auto;
  padding: 10px;
  ${({ theme }) => theme.mediaWidth.upToXxs`
    width: 145px;
    padding: 15px 6px;
  `}
  flex-direction: column;
`;

export const ImgContainer = styled.div`
  width: 116px;
  height: 116px;
  border: 2px solid #000;
  ${({ theme }) => theme.mediaWidth.upToXxs`
    width: 130px;
    height: 130px;
  `}
`;

export const DogeImg = styled.img`
  width: 100%;
  object-fit: cover;
`;

export const DogeInfo = styled.div`
  margin: auto;
  font-size: 21px !important;
  ${({ theme }) => theme.fontStyle.button}
`;

export const StyledDotsWrapper = styled.ul`
  bottom: -50px;
  .slick-active > .custom-dots {
    background-color: ${({ theme }) => theme.colors.primary60};
    border: 2px solid black;
  }
`;

export const StyledDots = styled.div`
  width: 18px;
  height: 18px;
  background: ${({ theme }) => theme.colors.neutral40};
  border-radius: 50%;
`;

export const NextArrow = styled.div`
  top: 43%;
  ::before {
    content: url(${NextIcon});
    padding: 8px;
    background-color: ${({ theme }) => theme.colors.neutral20};
    border-radius: 8px;
    display: flex;
    opacity: 1;
    width: fit-content;
  }
`;
export const PrevArrow = styled.div`
  top: 43%;
  left: -46px;
  ::before {
    content: url(${PrevIcon});
    padding: 8px;
    background-color: ${({ theme }) => theme.colors.neutral20};
    border-radius: 8px;
    display: flex;
    opacity: 1;
    width: fit-content;
  }
`;
